import { getAccessToken, loginRefreshToken } from '../LoginUser'
import { UserAPICall } from './UserRequestUtil'
import { CHANGEPASSWORD_URL } from '../../config/config'


export const passwordChange = async (param) => {

  await loginRefreshToken();

  const parameter = {
    previousPassword: param.currentpassword,
    proposedPassword: param.newpassword,
    accessToken:  getAccessToken(),
  };
  const res = await UserAPICall(CHANGEPASSWORD_URL,parameter);

  console.log(res)

  return;
};
